import _map from 'lodash/map';
import _zipObject from 'lodash/zipObject';

import { UPDATE_TRIGGERS } from 'constants/actions';
import { ALL } from 'constants/triggers';

const DEFAULT_TRIGGER_OBJECT = {
  complete: false,
  show: false,
};

const DEFAULT_TRIGGERS = _zipObject(
  ALL,
  _map(ALL, () => DEFAULT_TRIGGER_OBJECT)
);

const DEFAULT_TRIGGERS_STATE = { triggers: DEFAULT_TRIGGERS };

const triggersReducers = (state = DEFAULT_TRIGGERS_STATE, action) => {
  switch (action.type) {
    case UPDATE_TRIGGERS:
      return {
        ...state,
        triggers: action.triggers,
      };
    default:
      return state;
  }
};

export default triggersReducers;
